import { api } from './api.js';
import { tokenService } from './tokenService.js';

/**
 * Serviço de notificações
 */
export const notificationService = {
  /**
   * Buscar todas as notificações do usuário
   */
  getNotifications: async (type = 'entity') => {
    try {
      const response = await api.get(`v2/api/notifications?type=${type}`);
      
      if (response.data.status === 200 && !response.data.error) {
        return {
          success: true,
          notifications: response.data.response
        };
      }
      
      return {
        success: false,
        error: 'Erro ao buscar notificações'
      };
    } catch (error) {
      console.error('Erro ao buscar notificações:', error);
      return {
        success: false,
        error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao buscar notificações'
      };
    }
  },

  /**
   * Marcar uma notificação como lida
   */
  markAsRead: async (notificationId) => {
    try {
      const response = await api.patch(`v2/api/notifications/${notificationId}/read`, {});
      
      if (response.data.status === 200 && !response.data.error) {
        return {
          success: true
        };
      }
      
      return {
        success: false,
        error: 'Erro ao marcar notificação como lida'
      };
    } catch (error) {
      console.error('Erro ao marcar notificação como lida:', error);
      return {
        success: false,
        error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao marcar notificação'
      };
    }
  },

  /**
   * Marcar todas as notificações como lidas
   */
  markAllAsRead: async () => {
    try {
      const response = await api.patch('v2/api/notifications/read-all', {});
      
      if (response.data.status === 200 && !response.data.error) {
        return {
          success: true
        };
      }
      
      return {
        success: false,
        error: 'Erro ao marcar todas as notificações como lidas'
      };
    } catch (error) {
      console.error('Erro ao marcar todas as notificações:', error);
      return {
        success: false,
        error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao marcar notificações'
      };
    }
  }
};
